import { CustomCommands } from "@/shared/utils";
import { Button, Editor } from "grapesjs";
import { addFa6Icon } from "@/shared/iconBuilder";

export function addEditorButtons(editor: Editor, isSupport: boolean) {

  editor.Panels.removeButton("options", "export-template");

  if (isSupport) {
    editor.Panels.addButton("options", {
      id: "load-template",
      command: (editor: Editor) =>
        editor.runCommand(CustomCommands.MODAL_SELECT_TEMPLATES_OPEN),
      attributes: {
        title: "Load template",
        class: addFa6Icon("fa-browsers").addBorder(),
      },
    });
  }

  // DIVIDERS

  editor.Panels.addButton("options", {
    id: "live-template",
    tagName: "button",
    className: addFa6Icon("fa-magnifying-glass-play"),
    command: (editor: Editor) =>
      editor.runCommand(CustomCommands.TEMPLATE_OPEN_LIVE),
    attributes: { title: "Live preview" },
  });
  editor.Panels.addButton("options", {
    id: "preview-template",
    tagName: "button",
    className: addFa6Icon("fa-magnifying-glass-waveform").addBorder(),
    command: (editor: Editor) =>
      editor.runCommand(CustomCommands.TEMPLATE_OPEN_PREVIEW),
    attributes: { title: "Draft preview" },
  });

  // DIVIDERS

  editor.Panels.addButton("options", {
    id: "media-library",
    command: (editor: Editor) =>
      editor.AssetManager.open(),
    attributes: {
      title: "Media library",
      class: addFa6Icon("fa-images"),
    },
  });

  editor.Panels.addButton("options", {
    id: "edit-favicon",
    command: (editor: Editor) =>
      editor.runCommand(CustomCommands.MODAL_FAVICON_OPEN),
    attributes: {
      title: "Edit favicon",
      class: addFa6Icon("fa-star"),
    },
  });

  editor.Panels.addButton("options", {
    id: "edit-open-graph",
    command: (editor: Editor) =>
      editor.runCommand(CustomCommands.MODAL_OPEN_GRAPH_OPEN),
    attributes: {
      title: "Show social media sharing & OpenGraph",
      class: addFa6Icon("fa-share-nodes"),
    },
  });

  editor.Panels.addButton("options", {
    id: "publish-template",
    command: (editor: Editor) =>
      editor.runCommand(CustomCommands.TEMPLATE_PUBLISH_OPEN),
    attributes: {
      title: "Publish",
      class: addFa6Icon("fa-upload").addBorder(),
    },
  });
  // DIVIDERS

  editor.Panels.addButton("options", {
    id: "save",
    command: (editor: Editor) => {
      editor.store({
        explicit: true,
      });
    },
    attributes: {
      title: "Save",
      class: addFa6Icon("fa-save").addBorder(),
    },
  });
  // DIVIDERS
  editor.Panels.addButton("options", {
    id: "show-more",
    attributes: {
      title: "More",
      class: addFa6Icon("fa-ellipsis"),
      id: "show-more-options",
    },
  });

  // Helper function to apply icons to panel buttons
  const applyIconsToPanel = (panelId: string) => {
    editor.Panels.getPanel(panelId)
      ?.get("buttons")
      ?.map((button: Button) => {
        // @ts-ignore
        const fa6Icon = fa6IconsMapping[button.id];
        fa6Icon && button.set("className", addFa6Icon(fa6Icon));
      });
  };

  // Apply icons to both panels
  applyIconsToPanel("options");
  applyIconsToPanel("views");

  editor.on("run:preview", () => {
    const prvBtn = document.querySelector(".gjs-off-prv");
    if (prvBtn?.classList.contains("fa")) {
      prvBtn?.classList.remove("fa");
      prvBtn?.classList.remove("fa-eye-slash");

      prvBtn?.classList.add("fa-sharp");
      prvBtn?.classList.add("fa-light");
      prvBtn?.classList.add("fa-xmark-large");
    }
  });

  editor.Panels.removePanel("commands");
}

const fa6IconsMapping = {
  "sw-visibility": "fa-border-inner",
  preview: "fa-eyes",
  fullscreen: "fa-arrows-maximize",
  "export-template": "fa-code",
  "open-sm": "fa-paintbrush-fine",
  "open-tm": "fa-cog",
  "open-layers": "fa-layer-group",
  "open-blocks": "fa-grid-2-plus",
};
